import { fetchPublicScratchCampaign } from '@/lib/api/scratch-campaigns-public.service'
import { ApiClientError } from '@/lib/api/client'
import { RaspadinhaPublicCampaignUnavailableError } from './raspadinha-public-errors'

const DEFAULT_NOT_FOUND_MESSAGE = 'Campanha raspadinha não encontrada.'
const DEFAULT_LOAD_ERROR_MESSAGE =
  'Não foi possível carregar a campanha. Tente novamente em instantes.'

function resolveUnavailableMessage(err: ApiClientError): string {
  const message = err.message.trim()
  if (message && message !== `Erro HTTP ${err.status}`) {
    return message
  }
  return DEFAULT_NOT_FOUND_MESSAGE
}

/**
 * Carrega campanha raspadinha para a página pública via API.
 */
export async function fetchRaspadinhaPublicCampaign(
  slug: string
): Promise<import('@/types/raspadinha-public-campaign').RaspadinhaPublicCampaign> {
  try {
    return await fetchPublicScratchCampaign(slug)
  } catch (err) {
    if (err instanceof ApiClientError) {
      if (err.status === 404) {
        throw new RaspadinhaPublicCampaignUnavailableError(resolveUnavailableMessage(err), 404)
      }
      if (err.status === 0) {
        throw new RaspadinhaPublicCampaignUnavailableError(
          'Erro de conexão. Verifique sua internet e tente novamente.',
          0
        )
      }
      if (err.status >= 500) {
        throw new RaspadinhaPublicCampaignUnavailableError(DEFAULT_LOAD_ERROR_MESSAGE, err.status)
      }
      throw new RaspadinhaPublicCampaignUnavailableError(
        err.message.trim() || DEFAULT_LOAD_ERROR_MESSAGE,
        err.status
      )
    }

    if (err instanceof Error && err.message.toLowerCase().includes('não encontrad')) {
      throw new RaspadinhaPublicCampaignUnavailableError(
        err.message.trim() || DEFAULT_NOT_FOUND_MESSAGE,
        404
      )
    }

    if (
      err instanceof Error &&
      (err.message.includes('404') || err.message.toLowerCase().includes('not found'))
    ) {
      throw new RaspadinhaPublicCampaignUnavailableError(DEFAULT_NOT_FOUND_MESSAGE, 404)
    }

    throw err
  }
}
